// tslint:disable:max-line-length

import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.prod';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, EMPTY } from 'rxjs';
import { catchError, shareReplay, filter, map, takeWhile, tap } from 'rxjs/operators';
import { MessageToastService } from '../common/message-toast.service';
import { IKeyValueForm, IKeyDoubleValue, IKeyDoubleValueQueryResult } from '../../models/ikeyvalue.interface';
import { INewNameEmail } from '../../models/inewname.interface';
import { HTTP_CONTENT_HEADERS } from '../../shared/data/const.data';
import { ConferenceContentByEmailType } from '../../models/iconference.interface';
import { AbstractItem, AbstractItemReview, AbstractItemReviewForm, AbstractQueryResult, AbstractStaticsticsRecord, AbstractStatusNewForm, AbstractStatusResponse, AbstractTableItem, AbstractUserResource, AbstractUserResponse, AbstractVideoLinkForm } from 'src/app/models/abstract.model';
import { AbstractMainAuthorForm } from 'src/app/models/Iabstracttableitem';
import * as saveAs from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class AbstractService {

  private url = 'abstract';

  private api = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private msg: MessageToastService
  ) { }

  getAll(): Observable<AbstractTableItem[]> {
    return this.http.get<AbstractTableItem[]>(`${this.api}${this.url}`).pipe(
      catchError(err => {
        console.log('Service_Error => getAll():');
        console.log(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  // tslint:disable-next-line:no-shadowed-variable
  getTable(filter: string): Observable<AbstractQueryResult> {
    return this.http.get<AbstractQueryResult>(`${this.api}${this.url}/table/?${filter}`).pipe(
      catchError(err => {
        console.log('getTable_Error:');
        console.log(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  getSingle(id: string): Observable<AbstractItem> {
    return this.http.get<AbstractItem>(`${this.api}${this.url}/${id}`).pipe(
      // catchError(err => {
      //   console.log('GetSingleERROR');
      //   console.log(err);
      //   return EMPTY;
      // }),
      shareReplay()
    );
  }

  getSingleReview(id: string): Observable<AbstractItemReview> {
    return this.http.get<AbstractItemReview>(`${this.api}${this.url}/review/${id}`).pipe(
      shareReplay()
    );
  }

  update(id: string, obj: AbstractItem): Observable<AbstractItem> {
    return this.http.put<AbstractItem>(`${this.api}${this.url}/${id}`, obj).pipe(
      catchError(err => {
        console.log('UpdateAbstractError');
        console.log(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  delete(id: string) {
    return this.http.delete(`${this.api}${this.url}/${id}`).pipe(
      catchError(err => {
        console.log('DeleteAbstractERROR');
        console.log(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  deleteMulti(confId: number, ids: string[]) {
    return this.http.post(`${this.api}${this.url}/conference/${confId}/abstracts/delete`, ids).pipe(
      catchError(err => {
        console.log('DeleteAbstractERROR');
        console.log(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  // ЭКСПОРТ ТЕЗИСОВ В WORD
  exportOneAbstractToWord(id: string) {
    const url = `${ this.api }${ this.url }/${ id }/get-wordfile-one-abstract`;
    let hdrs = new HttpHeaders();
    hdrs = hdrs.set('Accept', HTTP_CONTENT_HEADERS.Word);

    return this.http.get(
      url,
      {
        observe: 'response',
        headers: hdrs,
        responseType: 'blob'
      }
    ).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        console.log('WORD ERROR:');
        console.log(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  exportAllAbstractsToWord(confId: number, isOnlyAccepted: boolean) {

    const url = `${ this.api }${ this.url }/${ confId }/download-word-all-abstracts`;
    let params = new HttpParams().set('isOnlyAccepted', isOnlyAccepted.toString());
    let hdrs = new HttpHeaders();
    hdrs = hdrs.set('Accept', HTTP_CONTENT_HEADERS.Word);

    return this.http.get(
      url,
      {
        observe: 'response',
        headers: hdrs,
        responseType: 'blob',
        params: params
      }
    ).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        console.log('WORD ERROR:');
        console.log(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  exportAbstractsToWord(confId: number, form: string[]) {
    const url = `${ this.api }${ this.url }/${ confId }/download-word-abstracts`;

    let hdrs = new HttpHeaders();
    hdrs = hdrs.set('Accept', HTTP_CONTENT_HEADERS.Word);

    return this.http.post(
      url, form,
      {
        observe: 'response',
        headers: hdrs,
        responseType: 'blob'
      },

    ).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        console.log('WORD ERROR:');
        console.log(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  // МЕТОДЫ ДЛЯ ТАБЛИЦЫ abstract_user
  postUserToAbstractUSer(abstractUser: AbstractUserResource) {
    return this.http.post(`${this.api}${this.url}/abstract-user-post`, abstractUser)
      .pipe(
        shareReplay()
      );
  }



  // МЕТОДЫ ДЛЯ СПРАВОЧНИКА "СТАТУСЫ ТЕЗИСА"
  import(form: IKeyValueForm[]) {
    return this.http.post(`${this.api}${this.url}/import-dict`, form);
  }

  // tslint:disable-next-line:no-shadowed-variable
  getAllStatusesTable(filter: string): Observable<IKeyDoubleValueQueryResult> {
    return this.http.get<IKeyDoubleValueQueryResult>(`${this.api}${this.url}/dict-statuses/?${filter}`)
      .pipe(
        catchError(err => {
          this.msg.errorEx(err);
          return EMPTY;
        }),
        shareReplay()
      );
  }

  // tslint:disable-next-line:no-shadowed-variable
  getTableStatuses(filter?: string): Observable<IKeyDoubleValueQueryResult> {
    return this.http.get<IKeyDoubleValueQueryResult>(`${this.api}${this.url}/table/dict-statuses/?${filter}`)
      .pipe(
        catchError(err => {
          this.msg.errorEx(err);
          return EMPTY;
        }),
        shareReplay()
      );
  }
  // tslint:disable-next-line:adjacent-overload-signatures
  getAllStatuses(): Observable<IKeyDoubleValue[]> {
    return this.http.get<IKeyDoubleValue[]>(`${this.api}${this.url}/table/dict-statuses/all`)
      .pipe(
        catchError(err => {
          this.msg.errorEx(err);
          return EMPTY;
        }),
        shareReplay()
      );
  }

  getTextByEmailTypeForStatus(abstractId: string, alias: string): Observable<ConferenceContentByEmailType> {
    return this.http.get<ConferenceContentByEmailType>(`${ this.api }${ this.url }/${ abstractId }/${ alias }/get-text-email-by-type`)
      .pipe(shareReplay());
  }

  updateDictStatus(id: number, obj: INewNameEmail): Observable<IKeyDoubleValue> {
    return this.http.put<IKeyDoubleValue>(`${this.api}${this.url}/update-dict-status/${id}`, obj)
      .pipe(
        catchError(err => {
          this.msg.errorEx(err);
          return EMPTY;
        }),
        shareReplay()
      );
  }

  addDictStatus(obj: INewNameEmail): Observable<IKeyDoubleValue> {
    return this.http.post<IKeyDoubleValue>(`${this.api}${this.url}/dict-status`, obj)
      .pipe(
        catchError(err => {
          this.msg.errorEx(err);
          return EMPTY;
        }),
        shareReplay()
      );
  }

  deleteDictStatus(ids: number[]) {
    return this.http.post(`${this.api}${this.url}/delete-dict-status`, ids)
      .pipe(
        catchError(err => {
          this.msg.errorEx(err);
          return EMPTY;
        }),
        shareReplay()
      );
  }

  export() {
    const url = `${this.api}${this.url}/export-dict-statuses`;

    let hdrs = new HttpHeaders();
    hdrs = hdrs.set('Accept', HTTP_CONTENT_HEADERS.Excel);

    return this.http.get(
      url,
      {
        observe: 'response',
        headers: hdrs,
        responseType: 'blob'
      }
    ).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  // Статистика
  getStat(conferenceId: number) {
    return this.http.get<AbstractStaticsticsRecord[]>(`${this.api}${this.url}/conference/${conferenceId}/stat`)
      .pipe(
        shareReplay()
      );
  }
  // Методы для получения рецензентов
  getPeopleInfoForTheses(absId: string) {
    return this.http.get<AbstractUserResponse[]>(`${this.api}${this.url}/theses-info-people-info/${absId}`)
      .pipe(
        shareReplay()
      );
  }

  putPeopleActiveForTheses(id: string, _absUsrRsp: AbstractUserResponse) {
    return this.http.put<AbstractUserResponse>(`${this.api}${this.url}/update-theses-people-info/${id}`, _absUsrRsp)
      .pipe(
        shareReplay()
      );
  }

  pdfCertificate(confId: number, abstractId: string) {
    const url = `${this.api}${this.url}/posters/${confId}/${abstractId}/certificate`;

    let hdrs = new HttpHeaders();
    hdrs = hdrs.set('Accept', HTTP_CONTENT_HEADERS.Pdf)

    return this.http.get(url, { observe: 'response', headers: hdrs, responseType: 'blob' }).pipe(
      catchError(err => { this.msg.errorEx(err); return EMPTY; }),
      map((res) => (new Blob([res.body], { type: HTTP_CONTENT_HEADERS.Pdf }))),
      shareReplay()
    );
  }

  pdfCertificateMulti(confId: number) {
    const url = `${this.api}${this.url}/posters/${confId}/certificate`;

    let hdrs = new HttpHeaders();
    hdrs = hdrs.set('Accept', HTTP_CONTENT_HEADERS.Pdf)

    return this.http.get(url, { observe: 'response', headers: hdrs, responseType: 'blob' }).pipe(
      catchError(err => { this.msg.errorEx(err); return EMPTY; }),
      map((res) => (new Blob([res.body], { type: HTTP_CONTENT_HEADERS.Pdf }))),
      shareReplay()
    );
  }

  // Методы для получения статусов тезисиса
  getStatusesForTheses(absId: string) {
    return this.http.get<AbstractStatusResponse[]>(`${this.api}${this.url}/theses-info-statuses-info/${absId}`)
      .pipe(shareReplay());
  }

  postNewThesesStatus(absStat: AbstractStatusNewForm) {
    return this.http.post(`${this.api}${this.url}/post-new-theses-status`, absStat)
      .pipe(
        shareReplay()
      );
  }

  updateAbstractAuthor(abstractId: string, form: AbstractMainAuthorForm) {
    return this.http.put(`${this.api}${this.url}/${abstractId}/author`, form).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  updateAbstractReview(abstractId: string, form: AbstractItemReviewForm) {
    return this.http.post(`${this.api}${this.url}/review/${abstractId}/update`, form)
    .pipe(
      shareReplay()
    );
  }

  sendAbstractPoster(conferenceId: number, abstractId: string, file: File) {
    const formData = new FormData();
    formData.append('pdf', file);

    return this.http.post(`${this.api}${this.url}/posters/${conferenceId}/${abstractId}`, formData).pipe(
      // catchError(err => {
      //   this.msg.errorEx(err);
      //   return EMPTY;
      // }),
      shareReplay()
    );
  }

  deleteAbstractPoster(conferenceId: number, abstractId: string) {
    return this.http.delete(`${this.api}${this.url}/posters/${conferenceId}/${abstractId}`).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  getAbstractPoster(conferenceId: number, abstractId: string): Observable<File> {
    return this.http.get<File>(`${this.api}${this.url}/posters/${conferenceId}/${abstractId}`, { responseType: 'blob' as 'json' })
    .pipe(
      map((blob: Blob) => {
        const file = new File([blob], `poster_${abstractId}.pdf`, { type: 'application/pdf' });
        return file;
      }),
      shareReplay()
    );
  }

  downloadAbstractPoster(conferenceId: number, abstractId: string) {
    const url = `${this.api}${this.url}/posters/${conferenceId}/${abstractId}`;
    let hdrs = new HttpHeaders();
    hdrs = hdrs.set('Accept', HTTP_CONTENT_HEADERS.Pdf);
    return this.http.get(
      url, {
        observe: 'response',
        headers: hdrs,
        responseType: 'blob'
      }).pipe(
        catchError(err => {
          this.msg.errorEx(err);
          console.log('PDF Error:', err);
          return EMPTY;
        }),
        shareReplay()
      );
  }

  mergeAndDownloadPostersPDF(conferenceId: number) {
    this.http.get(`${this.api}${this.url}/posters/${conferenceId}`, { responseType: 'blob' }).subscribe((blob: Blob) => {
      const fileName = `posterMerged_${conferenceId}.pdf`;
      saveAs(blob, fileName);
    });
  }

  saveVideoLink(conferenceId: number, abstractId: string, form: AbstractVideoLinkForm) {
    const url = `${this.api}${this.url}/video-link/${ conferenceId }/${ abstractId }`;
    return this.http.post(url, form)
    .pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      tap(() => this.msg.success('Ссылка успешно сохранена!')),
      shareReplay()
    );
  }

}
